import React, { Component } from 'react';
import { connect } from 'react-redux';
import {  Row, Col, Form, Input,  FormGroup } from 'reactstrap';
import { withRouter } from 'react-router';
import { customerDetailAction } from "../../actions";
import swal from 'sweetalert';
import { show, hide } from 'redux-modal';

class UpdateNote extends Component {
    constructor(props) {
        super(props)
        this.state = {
            formData: {
                id: '',
                notes: ''
            },
            errors: {},
        }
        this.handleChange = this.handleChange.bind(this)
        this.handelUpdateNote = this.handelUpdateNote.bind(this)
        this.afterAction = this.afterAction.bind(this)
        this.toggle = this.toggle.bind(this)
        this.handelCansel = this.handelCansel.bind(this)
    }
    toggle() {
        const { onClose } = this.props
        onClose()
    }


    handleChange(e) {
        e.preventDefault()
        const { formData } = this.state
        const { name, value } = e.target;

        if (name === "notes") {
            let regex_allowed = /^[a-zA-Z0-9 .,]+$/
            if (value.length && regex_allowed.test(value) === false) {
                return false;
            }
        }


        formData[name] = value;

        this.setState({ formData })
        console.log(formData)
        // const result = handleCompanyNameValidation()
        // this.setState({ errors: result.errors })
    }

    handelCansel() {
        const { dispatch } = this.props;
        dispatch(hide("bootstrap"))
    }

    afterAction() {
        const { dispatch, getCustomerList } = this.props;
        dispatch(hide("bootstrap"))
        getCustomerList()
    }

    handelUpdateNote(e) {
        e.preventDefault();
        const { formData } = this.state;
        const { dispatch } = this.props;

       // const result = handleCompanyNameValidation(formData)
        //this.setState({ errors: result.errors })
            //if (result.formIsValid) {
                swal({
                    title: "Are you sure ?",
                    text: "Do you want to update Note?",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                }).then((confirm) => {
                    if (confirm) {
                        formData.type = 'notes'
                        dispatch(customerDetailAction.updateCustomerDetilEmail(formData, this));
                    }
                })
            //}

        // else {
        //     dispatch(notify({ position: "tc", dismissible: false, message: '', status: "error" }))

        // }

    }
    componentDidMount() {
        const { customerDetail } = this.props;
        let { formData } = this.state;
        if (customerDetail) {
            formData.id = customerDetail.id
            formData.notes = customerDetail.notes ? customerDetail.notes : ''
            this.setState({ formData })
        }

    }
    render() {
        const { errors, formData } = this.state
        return (

            <React.Fragment>
                <Form autocomplete="off">
                    <Row>
                        <Col md="12">
                            <FormGroup >
                            <Input placeholder="Note" onChange={this.handleChange} value={formData.notes} name="notes" maxLength="100" />
                            {/* <FormFeedback>
                                {errors[`notes`] && errors[`notes`]}
                            </FormFeedback> */}

                            </FormGroup>
                        </Col>
                    </Row><hr />
                    <button className="btn btn-secondary btn-sm pull-right" onClick={this.handelCansel} style={{'marginLeft':'10px'}} > Cancel </button>
                    <button type="button" onClick={this.handelUpdateNote} className="btn btn-primary btn-sm pull-right"  > Update </button>
                </Form>
            </React.Fragment>

        )
    }
}

function mapStateToProps(state) {
    const { loading, data, customerDetail } = state.getCustomerStatusData
    return {
        loading,
        data,
        customerDetail
    }
}

const connectedUpdateNote = withRouter(connect(mapStateToProps)(UpdateNote))
export { connectedUpdateNote as UpdateNote }